import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getTransactionDetailsPath = (id: string = ':id') => urlHelper(`/transaction/${id}/details`);
